/**
 * Runtime-Konfiguration für die Anwendung
 *
 * Die Konfiguration wird aus window.__APP_CONFIG__ gelesen,
 * das durch /config.js bereitgestellt wird.
 */

export interface IAppConfig {
    apiUrl: string;
    sentryDsn?: string;
    istTestsystem?: boolean;
}

/**
 * Klasse für die Runtime-Konfiguration (komplett synchron)
 */
export class AppConfig {
    private getConfig(): IAppConfig {
        const config = (window as any).__APP_CONFIG__;

        if (!config) {
            throw new Error('App-Konfiguration nicht gefunden. ' + 'Stellen Sie sicher, dass /config.js geladen wurde.');
        }

        return config;
    }

    get apiUrl(): string {
        return this.getConfig().apiUrl;
    }

    get sentryDsn(): string | undefined {
        return this.getConfig().sentryDsn;
    }

    get istTestsystem(): boolean | undefined {
        return this.getConfig().istTestsystem;
    }
}

// Exportiere eine Instanz
export const appConfig = new AppConfig();
